<template>
  <div class="card-element relative">
    <label v-if="label" class="text-sm won-blue font-medium">{{ label }}</label>
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    default: '',
  },
}
</script>

<style>
</style>
